import * as React from 'react';
import * as styles from './ResidentialComplexesList.css';

interface IResidentialComplexesListProps {
  complexesList: React.ReactElement[];
  showMoreButton: React.ReactElement | null;
}

export function ResidentialComplexesList(props: IResidentialComplexesListProps) {
  const { complexesList, showMoreButton } = props;

  return (
    <section className={styles['complexes']}>
      <div className={styles['cards']}>{complexesList}</div>
      <div className={styles['button-wrapper']}>{showMoreButton}</div>
    </section>
  );
}
